import React from 'react';

import NavigationItem from './NavigationItem';

const NavigationItems = (props) => {

	const {
		list
	} = props;

	return (
		<ul className='navigationItems'>
			<NavigationItem key={list.length} link='/' alt='Home' linkText='Home' />
			{list.map(listItem => {
				return <NavigationItem key={listItem.id} link={listItem.url} alt={listItem.pageDescription} linkText={listItem.pageTitle} />;
			})}
		</ul>
		);
	};

	export default NavigationItems;
